<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+programId" :props="props" :map="map" :bus="bus"
            edit-button="1" :endpoint-params="endpointParams"
            button-icon="edit" :button-name="lang.polaris.form.edit" :button-handler="edit">
        </trax-ui-top-box>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id" :bus="bus">
            <enac-custom-atpl-program-edit-form :bus="bus" :id="id" :toastr-id="id+'-toastr'" :endpoint="endpoint">
            </enac-custom-atpl-program-edit-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-training-program-edit-top-box'},
            programId: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/programs',
                props: {
                    name: { source:'name' },
                    description: {source: 'description'},
                    status: {source: 'status'},
                    meta: {source: 'meta'}
                },
                map: {
                    title1: 'name',
                    description: 'description',
                    status: 'status',
                    backgroundImage: function(data) {
                        return data.meta && data.meta.background ? data.meta.background : 'default.jpg'
                    }
                },
                endpointParams: {
                    relations: ['biIndex', 'gcIndex']
                },
                bus: new Vue()
            }
        },

        methods: {

            edit: function(data) {
                this.bus.$emit(this.id+'-update', data);
            }
        }
    }
</script>
